import { useRouter } from 'found';
import PropTypes from 'prop-types';
import React from 'react';
import ProductCard from 'containers/cards/Product';

const ProductList = ({
  data,
  viewer,
  handleLike,
  dataKey = 'discoverProducts',
}) => {
  const { router } = useRouter();

  return data?.[dataKey]?.data?.map(list => (
    <ProductCard
      compact
      key={list.id}
      onClick={() => router.push(`/products/${encodeURIComponent(list.slug)}`)}
      product={list}
      viewer={viewer}
      handleLike={handleLike}
    />
  ));
};

ProductList.propTypes = {
  data: PropTypes.object.isRequired,
  style: PropTypes.object,
  viewer: PropTypes.object.isRequired,
  handleLike: PropTypes.any.isRequired,
  dataKey: PropTypes.string,
};

export default ProductList;
